import { useMemo } from 'react';
import { usePendo } from 'features/pendo/hooks/usePendo';
import { PendoEventType } from 'features/pendo/types';
import {
  useGetInstructionsQuery,
  useMarkInstructionAsReadMutation,
} from 'services/instructionsService';

export const useInstructionsData = () => {
  const { data: instructions, isLoading, refetch: refetchInstructions } = useGetInstructionsQuery();
  const [markInstructionAsRead] = useMarkInstructionAsReadMutation();
  const { trackEvent } = usePendo();

  const markInstructionsAsRead = async () => {
    if (!instructions) return;

    const unreadInstructionsIds = instructions
      .filter((instruction) => !instruction.read_by_patient)
      .map((instruction) => instruction.id);

    const readInstructionsReponse = await Promise.allSettled(
      unreadInstructionsIds.map((instructionId) => markInstructionAsRead(instructionId)),
    );

    readInstructionsReponse.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        trackEvent(PendoEventType.READ_INSTRUCTION, {
          eventType: PendoEventType.READ_INSTRUCTION,
          instructionId: `${unreadInstructionsIds[index]}`,
        });
      }
    });
  };

  const hasUnreadInstructions = useMemo(
    () => (instructions ? instructions.some((instruction) => !instruction.read_by_patient) : false),
    [instructions],
  );

  return {
    instructions,
    hasUnreadInstructions,
    isLoading,
    markInstructionsAsRead,
    refetchInstructions,
  };
};
